import React, { Component } from 'react'
import { Names, ContactPoints, CodeableConcept, Communications, OnsetDateTime } from '../helpers'
import { FaFemale, FaMale, FaLanguage } from 'react-icons/fa'
import { BsFillTelephoneFill } from 'react-icons/bs'
import moment from 'moment'
import './resource.css'

class PatientSmall extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Allergy${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.clinicalStatus && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.clinicalStatus && CodeableConcept(this.props.resource.clinicalStatus)}</div>
                        </div>
                        <div className='Res-Icon-Big'>{this.props.resource.gender === 'female' ? <FaFemale /> : <FaMale />}</div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.verificationStatus && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.verificationStatus && CodeableConcept(this.props.resource.verificationStatus)}</div>
                        </div>
                    </div>
                    <div className="Res-Row">
                        <div className="Res-Title">{this.props.resource.name ? Names(this.props.resource.name)  : 'Patient'}</div>
                    </div>
                    {this.props.resource.telecom && <div className='Res-Row'>
                        <span className={`Res-Icon`}><BsFillTelephoneFill /></span>
                        <div className='Res-Detail'>{ContactPoints(this.props.resource.telecom)}</div>
                    </div>}
                    {this.props.resource.communication && <div className='Res-Row'>
                        <span className={`Res-Icon`}><FaLanguage /></span>
                        <div className='Res-Detail'>{Communications(this.props.resource.communication)}</div>
                    </div>}
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.birthDate && 'DOB'}</div>
                            <div className='Res-Title'>{this.props.resource.birthDate && moment(this.props.resource.birthDate).format('ll')}</div>
                        </div>
                        {this.props.resource.deceasedBoolean && <div className='Res-Row Res-Title'>Deceased</div>}
                        {this.props.resource.deceasedBoolean && <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.deceasedDateTime && 'DOB'}</div>
                            <div className='Res-Title'>{OnsetDateTime(this.props.resource.deceasedDateTime)}</div>
                        </div>}
                    </div>
                </div>
            }
        </div></div>
    }
}

export default PatientSmall